import { createFeatureSelector, createSelector } from '@ngrx/store';

import { FertilisersState } from '../../models';

export const getFertiliserState = createFeatureSelector<FertilisersState>('fertilisers');

export const selectFertiliserOrderplan = createSelector(
  getFertiliserState,
  (state: FertilisersState) => state.fertiliserOrderplan || [],
);

export const selectNonOrderableFertilisers = createSelector(
  getFertiliserState,
  (state: FertilisersState) => state.nonOrderableFertilisers || [],
);

export const selectProprietaryFertilisers = createSelector(
  getFertiliserState,
  (state: FertilisersState) => state.proprietaryFertilisers || [],
);

export const selectArticlesByCropAids = createSelector(
  getFertiliserState,
  (state: FertilisersState) => state.articlesByCropAids || [],
);

export const selectCustomerFertilizerStock = createSelector(
  getFertiliserState,
  (state: FertilisersState) => state.customerFertilizerStock?.fertilizerStock || [],
);
